import { Component, Input } from "@angular/core";

import { SearchForm } from "../../forms/search.form";
import { SearchConfigurationModel } from "../../models/search-configuration.model";

@Component({
    selector: "[pcg-ng-search-filters]",
    templateUrl: "./search-filters.component.html"
})
export class SearchFiltersComponent {
    public isMobileFilterVisible: boolean = false;

    @Input()
    public searchConfiguration: SearchConfigurationModel;

    @Input()
    public searchForm: SearchForm;

    public toggleMobileFilter(): void {
        this.isMobileFilterVisible = !this.isMobileFilterVisible;
    }
}
